import formatAsCurrency from '../../../CommonUtils/formatAsCurrency';

export const LifeInsurance = {
  Married: [
    {
      title: (primaryName, spouseName) => `% of living expenses ${spouseName} Will Spend When ${primaryName} Dies`,
      template: value => `${Math.round((value * 100) * 100) / 100}%`,
      key: 'PctOfLivingExpensesSpouseWillSpendWhenPrimaryDies',
    },
    {
      title: (primaryName, spouseName) => `% of living expenses ${primaryName} Will Spend When ${spouseName} Dies`,
      key: 'PctOfLivingExpensesPrimaryWillSpendWhenSpouseDies',
      template: value => `${Math.round((value * 100) * 100) / 100}%`,
    },
    {
      title: (primaryName, spouseName) => `% of Current Income ${spouseName} Will Make if ${primaryName} Dies`,
      key: 'PcOfCurrentIncomeSpouseWillMakeIfPrimaryDies',
      template: value => `${Math.round((value * 100) * 100) / 100}%`,
    },
    {
      title: (primaryName, spouseName) => `% of Current Income ${primaryName} Will Make if ${spouseName} Dies`,
      key: 'PctOfCurrentIncomePrimaryWillMakeIfSpouseDies',
      template: value => `${Math.round((value * 100) * 100) / 100}%`,
    },
    {
      title: primaryName => `Additional Life Insurance to Purchase on ${primaryName} Life`,
      key: 'AdditionalLifeInsuranceToPurchaseOnPrimarysLife',
      template: value => formatAsCurrency(value),
    },
    {
      title: (primaryName, spouseName) => `Additional Life Insurance to Purchase on ${spouseName} Life`,
      key: 'AdditionalLifeInsuranceToPurchaseOnSpousesLife',
      template: value => formatAsCurrency(value),
    },
  ],
  Single: {
    NoChildren: [
      {
        title: primaryName => `Additional Life Insurance to Purchase on ${primaryName} Life`,
        key: 'AdditionalLifeInsuranceToPurchaseOnPrimarysLife',
        template: value => formatAsCurrency(value),
      },
    ],
    WithChildren: [
      {
        title: () => '% of living expenses Estate would spend',
        key: 'PctOfLivingExpensesEstateWouldSpend',
        template: value => `${Math.round((value * 100) * 100) / 100}%`,
      },
      {
        title: primaryName => `Additional Life Insurance to Purchase on ${primaryName} Life`,
        key: 'PctOfLivingExpensesEstateWouldSpend',
        template: value => formatAsCurrency(value),
      },
    ],
  },
};

export const LongTerm = [
  {
    title: primaryName => `Age When ${primaryName} Begins Care`,
    key: 'AgeWhenPrimaryBeginsCare',
    template: value => `Age ${value}`,
  },
  {
    title: primaryName => `Number of Years ${primaryName} will be in Care`,
    key: 'NumberOfYearsPrimaryWillBeInCare',
    template: value => `${value} Years`,
  },
  {
    title: primaryName => `Annual Cost of Care for ${primaryName}`,
    key: 'AnnualCostOfCareForPrimary',
    template: value => formatAsCurrency(value),
  },
  {
    title: primaryName => `Existing Daily Benefits for ${primaryName}`,
    key: 'ExistingDailyBenefitsForPrimary',
    template: value => `${formatAsCurrency(value)} Per Day`,
  },
  {
    title: primaryName => `Additional Care Purchased for ${primaryName}`,
    key: 'AdditionalCarePurchasedForPrimary',
    template: value => `${formatAsCurrency(value)} Per Day`,
  },
  {
    title: (primaryName, spouseName) => `Age When ${spouseName} Begins Care`,
    key: 'AgeWhenSpouseBeginsCare',
    template: value => `Age ${value}`,
  },
  {
    title: (primaryName, spouseName) => `Number of Years ${spouseName} will be in Care`,
    key: 'NumberOfYearsSpouseWillBeInCare',
    template: value => `${value} Years`,
  },
  {
    title: (primaryName, spouseName) => `Cost of Care for ${spouseName}`,
    key: 'CostOfCareForSpouse',
    template: value => formatAsCurrency(value),
  },
  {
    title: (primaryName, spouseName) => `Existing Daily Benefits for ${spouseName}`,
    key: 'ExistingDailyBenefitsForSpouse',
    template: value => `${formatAsCurrency(value)} Per day`,
  },
  {
    title: (primaryName, spouseName) => `Additional Care Purchased for ${spouseName}`,
    key: 'ExistingDailyBenefitsForSpouse',
    template: value => value,
  },
];

export const populateTitleWithPrimaryAndSpouseName = (assumptions, principal, spouse) => (
  assumptions.map(assumption => ({
    ...assumption,
    title: assumption.title(principal, spouse),
  }))
);

export const lifeInsuranceAssumptions = (isMarried, hasChildren) => {
  if (isMarried) {
    return LifeInsurance.Married;
  } else if (hasChildren) {
    return LifeInsurance.Single.WithChildren;
  }
  return LifeInsurance.Single.NoChildren;
};

export const populateAssumptionsLabel = (
  isMarried,
  hasChildren,
  principalName,
  spouseName,
) => {
  const lifeInsurance = lifeInsuranceAssumptions(isMarried, hasChildren);

  const insuranceAssumptions = [
    ...lifeInsurance,
    ...LongTerm,
  ];

  return populateTitleWithPrimaryAndSpouseName(
    insuranceAssumptions,
    principalName,
    spouseName,
  );
};
